/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { SIZE_XL, Text, TEXT_SIZE } from '@veeam/components';
import styled from 'styled-components';

const Title = styled(Text)`
    height: ${SIZE_XL};
    line-height: ${SIZE_XL};
`;

export interface LoginTitleProps {
    text: string;
    size?: TEXT_SIZE;
}

export const LoginTitle: React.FC<LoginTitleProps> = ({ text, size = TEXT_SIZE.xl }) => (
    <Title size={size}>
        {text}
    </Title>
);
